import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Auth } from '../../../autentication/Auth';
import { Util } from '../../../utils/util';
import { TransactionType } from '../../extract/extract.model';
import { PixReceipt } from '../models/receipt.model';
import { OperationType } from '../models/transaction.model';
import { PixTransferReturnSucesso } from '../models/transfer-return.model';
import { PixReceiptService } from './receipt.service';

@Component({
	selector: 'app-pix-receipt',
	templateUrl: './receipt.component.html',
	styleUrls: ['./receipt.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixReceiptComponent implements OnInit {
	public receipt: PixReceipt;
	public meuNome: string;
	public meuCpfCnpj: string;
	public id: number;
	public source: string;
	public title = '';
	public titlePayment = '';
	public operationType = OperationType;

	get showOperationType(): boolean{
		if((this.receipt.tipoOperacao === this.operationType.TROCO)
			|| (this.receipt.tipoOperacao === this.operationType.SAQUE)){
				return true;
			}

			return false;
	}

	get autenticationNumber(): string {
		return this.receipt.autenticacao;
	}

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private receiptService: PixReceiptService,
	) {}

	ngOnInit(): void {
		this.listenRoute();
		this.meuNome = Auth.getInstance().getUser().name;
	}

	listenRoute() {
		this.route.params.subscribe(params => {
			this.id = params.id;
			this.source = params.source;
			this.getReceipt();
		});
	}

	getReceipt() {
		this.receiptService.getReceipt(this.id).subscribe(result => {
			if (result && result.Existe && result.Sucesso) {
				const item = Util.keysToCamel(result.Retorno) as PixTransferReturnSucesso;
				this.receipt = this.receiptService.convertModelToReceipt(item);
				this.setTitle();
				this.setTitlePayment();
			}
		});
	}

	setTitle() {
		this.title = this.receipt.tipoTransacao === TransactionType.PIX_DEVOLUCAO_ENVIADA ? 'Comprovante de devolução' : 'Comprovante de transferência';
	}

	setTitlePayment() {
		this.titlePayment = this.receipt.tipoTransacao === TransactionType.PIX_DEVOLUCAO_ENVIADA ? 'Dados da devolução' : 'Informações de pagamento';
	}



	goBack() {
		if (this.source === 'lista') {
			this.router.navigate(['comprovantes/']);
		} else {
			this.router.navigate(['pix/']);
		}
	}

	emitPrint() {
		window.print();
	}

	getCpfCnpj(cpfCnpj: string) {
		return Util.maskCpfCnpjPix(cpfCnpj);
	}

	get myDocument(){
		return Auth.getInstance().getUser().cpfCnpj ? Auth.getInstance().getUser().cpfCnpj : Auth.getInstance().getUser().cpf;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/receipt/receipt.component.ts